export default "__VITE_ASSET__BIS2MRZM__"